import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-organization-chip',
    imports: [MatIconModule],
    templateUrl: './organization-chip.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./organization-chip.component.scss'],
})
export class OrganizationChipComponent {
    @Input() match = false;
}
